import { render, staticRenderFns } from "./FlashCardStartBtn.vue?vue&type=template&id=f7eea1de&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardStartBtn?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardStartBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports